import { SelectedBookingOptions } from 'entities/booking';
import { ClinicSelection } from 'entities/clinics';

import { observer } from 'mobx-react-lite';
import { Fragment } from 'react/jsx-runtime';

export const Clinics = observer(() => {
	return (
		<Fragment>
			<div className="mb-2 mt-2">
				<SelectedBookingOptions />
			</div>
			<ClinicSelection />
		</Fragment>
	);
});
